import axios, { AxiosResponse } from 'axios';
import { IApiModifyResponse } from '@/types';
import { IPlayerSearchResponse } from '@/types/player';

export const changePassword = (params: Record<string, string>): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/toolUser/changePassword', params);
};

export const changeTimeZone = (timeZoneCode: string): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/toolUser/changeTimeZone', { timezone: timeZoneCode });
};

export const searchPlayers = (query: string, platformIds?: number[], typeIds?: number[]): Promise<AxiosResponse<IPlayerSearchResponse>> => {
    const params: Record<string, string | number[]> = { query };
    if (platformIds?.length) {
        params['platform_ids[]'] = platformIds;
    }
    if (typeIds?.length) {
        params['type_ids[]'] = typeIds;
    }
    return axios.get('/api/toolUser/search', { params });
};
